import React from "react"
import { graphql } from "gatsby"
import { MediaItem } from "../../../../plugins/gatsby-plugin-atollon"

const VideoEmbed = ({ embed }) => {
  return (
    <section className="video-embed">
      <div className="video-embed__inner">
        <div className="video-embed__video">
          {embed && <MediaItem item={embed} />}
        </div>
      </div>
    </section>
  )
}

export default VideoEmbed

export const query = graphql`
  fragment VideoEmbedProps on DatoCmsVideoEmbed {
    ... on DatoCmsVideoEmbed {
      id
      embed: video {
        ...MediaItemProps
      }
    }
  }
`